import { render } from "./HeroPagination.vue?vue&type=template&id=43934db9"
import script from "./HeroPagination.vue?vue&type=script&lang=js"
export * from "./HeroPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__